// Widget CSS
import '@/css/_elementor/widgets/hero_section_static.css';

// ..........................................................................................

import { RandomImagePositions } from '@/js/utilities/random-image-positions';

// ..........................................................................................

// Hook into Elementor frontend init
window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/hero_section_static.default', (scope) => {
		const scopeEl = scope[0];

		// .........................................................

		const heroIcons = scopeEl.querySelector('.floating-icons');

		// Guard clause: Exit if heroIcons doesn't exist OR if it lacks 'is-random'
		if (!heroIcons || !heroIcons.classList.contains('is-random')) return;

		function updateRandomPositions() {
			new RandomImagePositions({
				container: heroIcons,
				items: '.floating-icon',
				padding: 64,
				cellSize: 150,
				centerGapHeight: 24, // vertical center no-placement zone
				topRightGap: window.innerWidth >= 1024 ? { width: 250, height: 150 } : { width: 0, height: 0 },
			});
		}

		setTimeout(() => {
			heroIcons.classList.add('is-ready');

			// Initialize positions on load
			updateRandomPositions();
		}, 150);

		// .........................................................
	});
});
